import React from 'react';
import P from "prop-types";

export default class Home extends React.Component {
    static propTypes = {
        location: P.any,
        history: P.any,
        actions: P.any
    };
    
    constructor(props) {
        super(props);
        this.state = {
            curTitle: "跳转中...",
        };
    }

    componentDidMount() {
        document.title = this.state.curTitle;
        try{
            let tempUrl = localStorage.getItem("turl");
            if(!!tempUrl){
                document.location.href = tempUrl;
            }else{
                this.props.history.push(`/quxiaoshuo/getMoneyNew`)
            }
        }catch(e){}
    }

    render() {
        return (
            <div></div>
        );
    }
}